module.exports = __webpack_public_path__ + "img/09.a6302691.jpeg";